import React, { useState, useEffect } from "react";
import Rating from "@mui/material/Rating";
import user1 from "../../../assets/ProductId/Ellipse (1).png";
import user2 from "../../../assets/ProductId/Ellipse.jpg";
import user3 from "../../../assets/ProductId/Ellipse.png";
import { getReviewByProductApi } from "../../../Apis/ReviewApi";
import { getAuth } from "@firebase/auth";
import { createReviewApi } from "../../../Apis/ReviewApi";

const CustomerReviews = ({ productID }) => {
  const auth = getAuth();

  const [isOpen, setIsOpen] = useState(false);

  const [newRating, setNewRating] = useState(0);

  const [newRatingContant, setNewRatingContant] = useState("");

  const [productReviewData, setProductReviewData] = useState([]);
  const [reviewDetails, setReviewDetails] = useState({});

  const getProductReview = async (productId) => {
    try {
      const response = await getReviewByProductApi(productId);
      if (response.productReviews && response.productReviews.length > 0) {
        setProductReviewData(response.productReviews);
        setReviewDetails(response.reviewDetails);
      } else {
        setProductReviewData([]);
        setReviewDetails({});
      }
    } catch (error) {
      console.error("Error fetching review by products", error);
      setProductReviewData([]);
      setReviewDetails({});
    }
  };

  useEffect(() => {
    getProductReview(productID);
  }, []);

  const togglePopup = async () => {
    if (newRatingContant.length > 0 && newRating === 0) return;
    const res = await createReviewApi(
      auth.currentUser.uid,
      productID,
      newRatingContant,
      parseInt(newRating)
    );

    console.log(res);
    setIsOpen(!isOpen);
    getProductReview(productID);

    setNewRating(0);
    setNewRatingContant("");
  };

  return (
    <div className="max-w-[1240px] m-auto">
      <div className="w-[1240px] h-[937px] bg-white mt-[35px] rounded-[10px] py-[29px] px-[35px] flex flex-col shadow-[0_0px_0px_1px_rgba(0,0,0,0.07)]">
        <div className="w-full h-[30px] flex items-start justify-between">
          <p className="text-[#FF6300] font-semibold text-[16px] w-[151px] h-[29px]">
            Review Summary :
          </p>
          <p className="text-black font-semibold text-[14px] w-[208px] h-[21px]">
            Total Customer Reviews : {productReviewData.length}
          </p>
        </div>
        <div className="w-full h-[57px] flex items-center justify-between mt-[16px]">
          <div className="w-[304px] h-[39px] bg-white border rounded-[5px]  font-semibold text-[14px] flex items-center justify-center">
            <p>Overall Review:</p>
            <Rating
              name="half-rating"
              defaultValue={2.5}
              precision={0.5}
              readOnly
              className="ml-[5px]"
            />
            <p>4.1 / 5</p>
          </div>

          <button
            className="w-[135px] h-[42px] bg-[#FF6300] rounded-[5px] flex items-center justify-center font-semibold text-[14px] text-white gap-x-[10px]"
            onClick={togglePopup}
          >
            <svg
              width="22"
              height="22"
              viewBox="0 0 22 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M19.5249 9.24069C19.2673 8.93145 18.945 8.68252 18.5807 8.51146C18.2164 8.3404 17.819 8.25138 17.4166 8.25069H13.2366L13.7499 6.93986C13.9634 6.36592 14.0345 5.74875 13.9571 5.14129C13.8797 4.53383 13.6561 3.95421 13.3055 3.45215C12.9549 2.9501 12.4877 2.54059 11.944 2.25876C11.4004 1.97692 10.7965 1.83118 10.1841 1.83403C10.0078 1.83439 9.83527 1.88561 9.68732 1.98154C9.53936 2.07746 9.42221 2.21403 9.34992 2.37486L6.73742 8.25069H4.58325C3.85391 8.25069 3.15443 8.54042 2.63871 9.05615C2.12298 9.57187 1.83325 10.2713 1.83325 11.0007V17.4174C1.83325 18.1467 2.12298 18.8462 2.63871 19.3619C3.15443 19.8776 3.85391 20.1674 4.58325 20.1674H16.2524C16.8957 20.1671 17.5186 19.9414 18.0127 19.5294C18.5068 19.1174 18.8408 18.5452 18.9566 17.9124L20.1208 11.4957C20.1928 11.0991 20.1767 10.6916 20.0737 10.3019C19.9708 9.91222 19.7834 9.54993 19.5249 9.24069ZM6.41659 18.334H4.58325C4.34014 18.334 4.10698 18.2374 3.93507 18.0655C3.76316 17.8936 3.66659 17.6605 3.66659 17.4174V11.0007C3.66659 10.7576 3.76316 10.5244 3.93507 10.3525C4.10698 10.1806 4.34014 10.084 4.58325 10.084H6.41659V18.334ZM18.3333 11.1657L17.1691 17.5824C17.13 17.7959 17.0165 17.9887 16.8486 18.1263C16.6807 18.264 16.4695 18.3376 16.2524 18.334H8.24992V9.35986L10.7433 3.74986C10.9999 3.82468 11.2383 3.9519 11.4433 4.12348C11.6483 4.29506 11.8155 4.50727 11.9344 4.74673C12.0532 4.98618 12.1212 5.24768 12.1339 5.51472C12.1466 5.78175 12.1038 6.04852 12.0083 6.29819L11.5224 7.60903C11.4189 7.88609 11.3839 8.18409 11.4206 8.4776C11.4572 8.7711 11.5642 9.05138 11.7326 9.29454C11.901 9.53769 12.1258 9.73649 12.3877 9.87396C12.6496 10.0114 12.9408 10.0835 13.2366 10.084H17.4166C17.5513 10.0838 17.6843 10.1133 17.8063 10.1703C17.9283 10.2273 18.0362 10.3105 18.1224 10.414C18.2107 10.5161 18.2754 10.6364 18.3119 10.7663C18.3483 10.8962 18.3556 11.0326 18.3333 11.1657Z"
                fill="white"
              />
            </svg>
            <p className="w-[83px] h-[21px]">Add Review</p>
          </button>
          {isOpen && (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
              <div className="bg-white pt-[32px] pb-[26px] px-[40px] rounded-[10px] w-[793px] h-[481px] flex flex-col">
                <div className="w-full flex items-center justify-center">
                  <h2 className="text-[16px] font-semibold w-[95px] h-[24px]">
                    Add Review
                  </h2>
                </div>
                <p className="w-[92px] h-[21px] font-semibold text-[14px] my-[20px]">
                  Rate Product
                </p>
                <div>
                  <Rating
                    name="half-rating"
                    defaultValue={newRating}
                    onChange={(event, newValue) => {
                      setNewRating(newValue);
                    }}
                    precision={0.5}
                  />
                </div>
                <p className="w-[80px] h-[21px] font-semibold text-[14px] mt-[25px]">
                  Comments
                </p>
                <textarea
                  onChange={(e) => setNewRatingContant(e.target.value)}
                  value={newRatingContant}
                  className="w-[713px] h-[168px] border border-gray-300 rounded-[10px] p-2 mt-[13px]"
                  placeholder="Write your review..."
                ></textarea>
                <div className="w-full flex items-center justify-center">
                  <button
                    className="bg-[#FF6300] text-white py-2 px-4 rounded-[5px] w-[116px] h-[42px] font-semibold text-[14px] mt-[26px]"
                    onClick={togglePopup}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="w-full flex-col h-[200px]">
          <div className="flex items-center mt-[22px]">
            <p className="w-[50px] h-[20px] font-semibold text-[14px]">
              5 Stars
            </p>
            <Rating
              name="half-rating"
              defaultValue={5.0}
              readOnly
              precision={0.5}
              className="ml-[5px]"
            />
            <hr className="w-[211px] h-[7px] bg-[#A4A4A4] rounded-full ml-[15px]" />
            <p className="w-[73px] h-[20px] text-[14px] font-semibold ml-[12px]">
              {(productReviewData.filter((review) => review.rating == 5)
                .length /
                productReviewData.length) *
                100}{" "}
              % (
              {productReviewData.filter((review) => review.rating == 5).length})
            </p>
          </div>
          <div className="flex items-center w-full mt-[15px]">
            <p className="w-[50px] h-[20px] font-semibold text-[14px]">
              4 Stars
            </p>
            <Rating
              name="half-rating"
              defaultValue={4.0}
              readOnly
              precision={0.5}
              className="ml-[5px]"
            />
            <hr className="w-[211px] h-[7px] bg-[#A4A4A4] rounded-full ml-[15px]" />
            <p className="w-[73px] h-[20px] text-[14px] font-semibold ml-[12px]">
              {((productReviewData.filter((review) => review.rating == 4)
                .length +
                productReviewData.filter((review) => review.rating == 4.5)
                  .length) /
                productReviewData.length) *
                100}{" "}
              % (
              {
                productReviewData.filter(
                  (review) => review.rating == 4 || review.rating == 4.5
                ).length
              }
              )
            </p>
          </div>
          <div className="flex items-center w-full mt-[15px]">
            <p className="w-[50px] h-[20px] font-semibold text-[14px]">
              3 Stars
            </p>
            <Rating
              name="half-rating"
              defaultValue={3.0}
              readOnly
              precision={0.5}
              className="ml-[5px]"
            />
            <hr className="w-[211px] h-[7px] bg-[#A4A4A4] rounded-full ml-[15px]" />
            <p className="w-[90px] h-[20px] text-[14px] font-semibold ml-[12px]">
              {((productReviewData.filter((review) => review.rating == 3)
                .length +
                productReviewData.filter((review) => review.rating == 3.5)
                  .length) /
                productReviewData.length) *
                100}{" "}
              % (
              {
                productReviewData.filter(
                  (review) => review.rating == 3 || review.rating == 3.5
                ).length
              }
              )
            </p>
          </div>
          <div className="flex items-center w-full mt-[15px]">
            <p className="w-[50px] h-[20px] font-semibold text-[14px]">
              2 Stars
            </p>
            <Rating
              name="half-rating"
              defaultValue={2.0}
              readOnly
              precision={0.5}
              className="ml-[5px]"
            />
            <hr className="w-[211px] h-[7px] bg-[#A4A4A4] rounded-full ml-[15px]" />
            <p className="w-[73px] h-[20px] text-[14px] font-semibold ml-[12px]">
              {((productReviewData.filter((review) => review.rating == 2)
                .length +
                productReviewData.filter((review) => review.rating == 2.5)
                  .length) /
                productReviewData.length) *
                100}{" "}
              % (
              {
                productReviewData.filter(
                  (review) => review.rating == 2 || review.rating == 2.5
                ).length
              }
              )
            </p>
          </div>
          <div className="flex items-center w-full mt-[15px]">
            <p className="w-[50px] h-[20px] font-semibold text-[14px]">
              1 Stars
            </p>
            <Rating
              name="half-rating"
              defaultValue={1.0}
              readOnly
              precision={1.0}
              className="ml-[5px]"
            />
            <hr className="w-[211px] h-[7px] bg-[#A4A4A4] rounded-full ml-[15px]" />
            <p className="w-[73px] h-[20px] text-[14px] font-semibold ml-[12px]">
              {((productReviewData.filter((review) => review.rating == 1)
                .length +
                productReviewData.filter((review) => review.rating == 1.5)
                  .length) /
                productReviewData.length) *
                100}{" "}
              % (
              {
                productReviewData.filter(
                  (review) => review.rating == 1 || review.rating == 1.5
                ).length
              }
              )
            </p>
          </div>
        </div>

        <hr className="w-[1170px] h-[2px] bg-[#E8E8E8] mt-[35px]" />

        {/* <div className="w-full h-full">
          <div className="w-[1170px] h-[120px] mt-[32px]">
            <div className="flex flex-row items-start gap-x-[20px]">
              <img src={user3} alt="user1" className="w-[40px] h-[40px]" />
              <div className="flex items-center justify-between w-full">
                <div>
                  <p className="font-semibold text-[15px]">
                    XYZ Company Pvt. Ltd
                  </p>
                  <Rating
                    name="half-rating-read"
                    defaultValue={2.5}
                    precision={0.5}
                    readOnly
                  />
                </div>
                <p className="text-[12px] font-medium h-[52px]">
                  11 March , 2024
                </p>
              </div>
            </div>

            <p className="w-[1160px] h-[66px] text-[14px] mt-[10px] leading-[25px]">
              Lorem ipsum dolor sit amet, consectetur adipisci elit, sed eiusmod
              tempor incidunt ut labore et dolore magna aliqua. Ut enim ad minim
              veniam, quis nostrud lorem exercitation ullamco laboris nisi ut
              aliquip ex ea commodo consequat. Duis aute irure dolor in
              reprehenderit in voluptate velit esse cillum dolore eu fugiat
              nulla pariatur.
            </p>
          </div>

          <hr className="w-[1170px] h-[1px] bg-[#E8E8E8] mt-[35px]" />

          <div className="w-[1170px] h-[120px] mt-[32px]">
            <div className="flex flex-row items-start gap-x-[20px]">
              <img src={user1} alt="user1" className="w-[40px] h-[40px]" />
              <div className="flex items-center justify-between w-full">
                <div>
                  <p className="font-semibold text-[15px]">
                    XYZ Company Pvt. Ltd
                  </p>
                  <Rating
                    name="half-rating-read"
                    defaultValue={2.5}
                    precision={0.5}
                    readOnly
                  />
                </div>
                <p className="text-[12px] font-medium h-[52px]">
                  11 March , 2024
                </p>
              </div>
            </div>

            <p className="w-[1160px] h-[66px] text-[14px] mt-[10px] leading-[25px]">
              Lorem ipsum dolor sit amet, consectetur adipisci elit, sed eiusmod
              tempor incidunt ut labore et dolore magna aliqua. Ut enim ad minim
              veniam, quis nostrud lorem exercitation ullamco laboris nisi ut
              aliquip ex ea commodo consequat. Duis aute irure dolor in
              reprehenderit in voluptate velit esse cillum dolore eu fugiat
              nulla pariatur.
            </p>
          </div>

          <hr className="w-[1170px] h-[1px] bg-[#E8E8E8] mt-[35px]" />

          <div className="w-[1170px] h-[120px] mt-[32px]">
            <div className="flex flex-row items-start gap-x-[20px]">
              <img src={user2} alt="user1" className="w-[40px] h-[40px]" />
              <div className="flex items-center justify-between w-full">
                <div>
                  <p className="font-semibold text-[15px]">
                    XYZ Company Pvt. Ltd
                  </p>
                  <Rating
                    name="half-rating-read"
                    defaultValue={2.5}
                    precision={0.5}
                    readOnly
                  />
                </div>
                <p className="text-[12px] font-medium h-[52px]">
                  11 March , 2024
                </p>
              </div>
            </div>

            <p className="w-[1160px] h-[66px] text-[14px] mt-[10px] leading-[25px]">
              Lorem ipsum dolor sit amet, consectetur adipisci elit, sed eiusmod
              tempor incidunt ut labore et dolore magna aliqua. Ut enim ad minim
              veniam, quis nostrud lorem exercitation ullamco laboris nisi ut
              aliquip ex ea commodo consequat. Duis aute irure dolor in
              reprehenderit in voluptate velit esse cillum dolore eu fugiat
              nulla pariatur.
            </p>
          </div>
        </div> */}
        <div className="w-full h-full">
          {productReviewData.slice(0, 2)?.map((review, index) => (
            <div>
              <div className="w-[1170px] h-[120px] mt-[32px]">
                <div className="flex flex-row items-start gap-x-[20px]">
                  <img src={user1} alt="user1" className="w-[40px] h-[40px]" />
                  <div className="flex items-center justify-between w-full">
                    <div>
                      <p className="font-semibold text-[15px]">{review.name}</p>
                      <Rating
                        name="half-rating-read"
                        defaultValue={parseInt(review.rating)}
                        precision={0.5}
                        readOnly
                      />
                    </div>
                    <p className="text-[12px] font-medium h-[52px]">
                      {review.createdOn.slice(0, 10)}
                    </p>
                  </div>
                </div>
                <p className="w-[1160px] h-[66px] text-[14px] mt-[10px] leading-[25px]">
                  {review.content}
                </p>
              </div>
              <hr className="w-[1170px] h-[1px] bg-[#E8E8E8] mt-[35px]" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CustomerReviews;
